import {
    formatSectionText,
    formatSectionTextSync,
    capitalizeWord,
    capitalizeSentence,
    capitalizeFirstWord,
    removeSectionNumberPrefix,
} from './sectionExtract'

export const extractFileName = (url) => {
    const rawFileNameAndParams = url.split('/').pop()
    const rawFileName = rawFileNameAndParams.split('?')[0]
    const fileName = rawFileName.split('%20').join(' ')
    return fileName
}

export const strCompare = (s1, s2) => s1.toLowerCase() === s2.toLowerCase()

export const createSectionNameFromDeliminatedString = (string, delimiter) => {
    if (typeof string !== 'string' || string === null || string === undefined || string === '') {
        return string
    }

    if (string.includes(delimiter)) {
        const sectionName = string.split(delimiter).join(' ')
        return capitalizeFirstWord(sectionName)
    } else {
        return string
    }
}

export const formatTitleFromDeliminatedString = (string, delimiter) => {
    if (typeof string !== 'string' || string === null || string === undefined || string === '') {
        return string
    }

    if (string.includes(delimiter)) {
        const titleParts = string.split(delimiter)
        const title = titleParts.map(part => capitalizeWord(part)).join(' ')
        return title
    } else {
        return string
    }
}

export const normalizeSectionTitle = (sectionTitle) => {
    const formattedInput = removeSectionNumberPrefix(sectionTitle)
    const normalizedTitle = formattedInput.replace(/[^\w]/g, '')
    return normalizedTitle
}

export const formatToolText = (toolText) => {
    const regex = /(?<=WHAT:)(.*?)(?=HOW:)/
    const match = toolText.match(regex)
    if (match) {
        return match[0].trim()
    }
    return toolText
}
